import {AxiosInstance} from 'axios';

export function addBlobCoercionInterceptor(instance: AxiosInstance) {
  instance.interceptors.response.use(response => {
    // Pull fileName from Content-Disposition if the server provided one.
    // Two grammar branches to handle separately:
    //   RFC 5987 — `filename*=UTF-8''my%20doc.pdf`  → percent-decode the value
    //   Legacy   — `filename="my doc.pdf"`          → DO NOT percent-decode (a
    //              literal '%' in the name would crash decodeURIComponent).
    let fileName: string | undefined | null;
    const cd: string | undefined = response.headers?.['content-disposition'];
    if (cd) {
      const ext = cd.match(/filename\*\s*=\s*(?:UTF-8'')?([^;\n]+)/i);
      if (ext && ext[1]) {
        try {
          fileName = decodeURIComponent(ext[1].replace(/^"|"$/g, ''));
        } catch {
          fileName = ext[1].replace(/^"|"$/g, '');
        }
      } else {
        const legacy = cd.match(/filename\s*=\s*([^;\n]+)/i);
        if (legacy && legacy[1]) {
          fileName = legacy[1].trim().replace(/^"|"$/g, '');
        }
      }
    }

    if (response.data instanceof Blob && fileName) {
      Object.assign(response.data, {fileName});
    }
    return response;
  });
}
